import cx from 'classnames';
import 'shaka-player-react/dist/controls.css';

import { useEffect, useRef } from 'react';

import ShakaPlayer from 'shaka-player-react';

export const VideoSectionUI = ({ active = false, id, url }) => {
  const preventWindowToScroll = (e) => {
    if (!document.fullscreenElement) {
      setTimeout(() => {
        const element = document.getElementById(e.target.id);
        element?.scrollIntoView();
      }, 250);
    }
  };

  useEffect(() => {
    const videoPlayers = document.querySelectorAll('.video-player');
    if (videoPlayers?.length > 0) {
      for (const element of videoPlayers) {
        element.addEventListener('fullscreenchange', preventWindowToScroll);
      }
    }

    return () => {
      if (videoPlayers.length > 0) {
        for (const element of videoPlayers) {
          element.removeEventListener('fullscreenchange', preventWindowToScroll);
        }
      }
    };
  }, []);

  if (!id || !url) return null;

  return (
    <div className={`video-box ${active ? '' : 'hide'}`} key={id}>
      <VideoSectionUIviaType url={url} id={id} />
    </div>
  );
};

export const VideoSectionUIviaType = ({
  url,
  id,
  className = '',
  style = {},
  containerClassname = '',
  containerStyle = {},
  autoPlay = true,
  playsInline = false
}) => {
  const filename = url?.split('?')?.[0]?.substring(url?.lastIndexOf('/') + 1);
  const isMpdFile = filename?.split('.')?.[1]?.toLowerCase() === 'mpd';

  const _id = id ? `video-player-${id}` : 'video-player';

  const videoRef = useRef(null);

  const config = {
    overflowMenuButtons: ['picture_in_picture', 'cast', 'playback_rate'],
  };
  const configureVideo = () => {
    if (videoRef.current && videoRef.current.ui && url) {
      videoRef.current.ui.configure(config);
    }
  };

  useEffect(() => {
    if (!videoRef.current) return;
    const timerId = setTimeout(() => {
      configureVideo();
    }, 1000);

    return () => {
      if (timerId) clearTimeout(timerId);
    };
  }, [videoRef, videoRef.current]);

  const onContextMenu = (e) => {
    e.preventDefault();
    return false;
  };

  if (!url) return null;

  return (
    <>
      {isMpdFile ? (
        <div
          id={_id}
          key={id}
          className={cx('video-player', containerClassname)}
          onContextMenu={onContextMenu}
          style={containerStyle}>
          <ShakaPlayer
            className={className}
            style={style}
            ref={videoRef}
            autoPlay={autoPlay}
            muted
            loop
            src={url}
            playsInline={playsInline}
          />
        </div>
      ) : (
        <video
          key={id}
          id={_id}
          className={cx('video-player', className)}
          loop
          controls
          muted
          autoPlay={autoPlay}
          playsInline
          controlsList="nodownload"
          onContextMenu={onContextMenu}
          style={style}>
          <source src={url} type="video/mp4" />
        </video>
      )}
    </>
  );
};
